import * as PIXI from 'pixi.js';
import Color from '../utils/Color';

export default class Rectangle extends PIXI.Rectangle {
  color = Color.BLACK;
  radius = 0;
  anchor = new PIXI.Point(0, 0);

  clone() {
    const rectangle = new Rectangle(this.x, this.y, this.width, this.height);
    rectangle.color = this.color;
    rectangle.radius = this.radius;
    rectangle.anchor = this.anchor.clone();
    return rectangle;
  }

  get alpha() {
    return this.color.getAlpha();
  }

  set alpha(value) {
    this.color.setAlpha(value);
  }

  /**
   * @param graphics {PIXI.Graphics}
   */
  draw(graphics) {
    graphics.beginFill(Color.toNumber(this.color), this.alpha);

    if (this.radius) {
      graphics.drawRoundedRect(
        this.x,
        this.y,
        this.width,
        this.height,
        this.radius
      );
    } else {
      graphics.drawRect(this.x, this.y, this.width, this.height);
    }

    graphics.endFill();
  }
}
